/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InheritedPermissionGrant from './InheritedPermissionGrant';
import PermissionGrant from './PermissionGrant';

/**
 * The AssetPermissions model module.
 * @module model/AssetPermissions
 * @version 1.0.0
 */
class AssetPermissions {
    /**
     * Constructs a new <code>AssetPermissions</code>.
     * @alias module:model/AssetPermissions
     */
    constructor() { 
        
        AssetPermissions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AssetPermissions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AssetPermissions} obj Optional instance to populate.
     * @return {module:model/AssetPermissions} The populated <code>AssetPermissions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AssetPermissions();

            if (data.hasOwnProperty('assetId')) {
                obj['assetId'] = ApiClient.convertToType(data['assetId'], 'String');
            }
            if (data.hasOwnProperty('grants')) {
                obj['grants'] = ApiClient.convertToType(data['grants'], [PermissionGrant]);
            }
            if (data.hasOwnProperty('inherited')) {
                obj['inherited'] = ApiClient.convertToType(data['inherited'], [InheritedPermissionGrant]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AssetPermissions</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AssetPermissions</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['assetId'] && !(typeof data['assetId'] === 'string' || data['assetId'] instanceof String)) {
            throw new Error("Expected the field `assetId` to be a primitive type in the JSON string but got " + data['assetId']);
        }
        if (data['grants']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['grants'])) {
                throw new Error("Expected the field `grants` to be an array in the JSON data but got " + data['grants']);
            }
            // validate the optional field `grants` (array)
            for (const item of data['grants']) {
                PermissionGrant.validateJSON(item);
            };
        }
        if (data['inherited']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['inherited'])) {
                throw new Error("Expected the field `inherited` to be an array in the JSON data but got " + data['inherited']);
            }
            // validate the optional field `inherited` (array)
            for (const item of data['inherited']) {
                InheritedPermissionGrant.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} assetId
 */
AssetPermissions.prototype['assetId'] = undefined;

/**
 * @member {Array.<module:model/PermissionGrant>} grants
 */
AssetPermissions.prototype['grants'] = undefined;

/**
 * @member {Array.<module:model/InheritedPermissionGrant>} inherited
 */
AssetPermissions.prototype['inherited'] = undefined;






export default AssetPermissions;

